import * as constants from './pipelines-types'

export default {
  [constants.SET_PIPELINES] (state, pipelines) {
    state.pipelines = pipelines
  },
}
